// src/pages/Home.jsx
import React from "react";
import slider from "../Images/sample-slider.jpg";
// import CountUp from "react-countup";
import ScrollCounter from "../Components/ScrollCounter";
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import cotton from '../Images/cotton-image.jpg'
import polysterBlend from '../Images/cotton-polyester-blended-fabric.png'
import viscosModal from '../Images/modal-image.jpg'
import viscosBlend from '../Images/viscose-blend-fabric.png'
import modalBlend from '../Images/modal-blend-image.jpg'
import linenImage from '../Images/linen-image.jpg'
import infrastructure from '../Images/infrastructure-image.jpg'
import recycleImage from '../Images/recycle-image.png'
import Footer from '../Components/Footer'
// import AOS from 'aos';
// import 'aos/dist/aos.css'; // You can also use <link> for styles
// // ..
// AOS.init();


const Home = () => {
  return (
    <div className="home-page">
      <div className="slider-section">
        <img className="slider-image" src={slider} alt="slider-image" />
      </div>
      <div className="homepage-sec-1">
        <div className="container">
          <div className="homepage-sec-1-cont">
            <div className="homepage-sec-1-left">
              <h1 data-aos="fade-up"  data-aos-duration="1000">About Us</h1>
              <p  data-aos="fade-up"  data-aos-duration="1000"  data-aos-delay="100">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure
                reiciendis modi adipisci alias consequuntur odit quos quod
                ipsam, maxime, fugit id ad dicta dolores! Deserunt molestiae
                explicabo et sapiente vero a numquam in, maxime quibusdam
                fugiat. At quibusdam sed autem deleniti minima, nam praesentium
                repudiandae, aut quae ad officia corrupti!
              </p>
              <button data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"><Nav.Link as={Link} to="/about">Know More</Nav.Link></button>
            </div>
            <div className="homepage-sec-1-right">
              <div className="counter-section" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
                <span className="counter-heading">
                  production <br />
                </span>

                <ScrollCounter start={0} end={5000} duration={5} />
                <span className="counter-desc">tons per month</span>
              </div>
              <div className="counter-section" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                <span className="counter-heading">
                  Till date<br />
                </span>

                <ScrollCounter start={0} end={15} duration={5} />
                <span className="counter-desc">tons dyeing done</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --------------- */}
      <div className="homepage-sec-2">
        <div className="container">
          <div className="homepage-sec-2-cont">
            <div className="homepage-sec-2-left">
              <h1 data-aos="fade-right" data-aos-duration="1000">What We Do</h1>
              <p data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100"><span>18+ varieties</span><br /> of fabrics we handle</p>
              <Nav.Link data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200" as={Link} to="/services">View More</Nav.Link>
            </div>
            <div className="homepage-sec-2-right">
              <div class="grid">
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000">
                  <img src={cotton} alt="cotton" />
                  <figcaption>
                    <h2><span>Cotton</span></h2>
                    <p>Pure Quality, Perfectly Colored </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
                  <img src={polysterBlend} alt="polyster Blend" />
                  <figcaption>
                    <h2><span>Cotton & <br /> Polyester blend</span></h2>
                    <p>The Fabric of Excellence <br />in Color and Clean </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                  <img src={viscosModal} alt="viscos-modal" />
                  <figcaption>
                    <h2> <span>Viscose / Modal /<br /> Tancel</span></h2>
                    <p>Where Purity Meets Perfect Dyeing </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000">
                  <img src={viscosBlend} alt="viscos blend" />
                  <figcaption>
                    <h2><span>Poly / <br />Viscose blend</span></h2>
                    <p>The Natural Choice for Flawless Colors </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
                  <img src={modalBlend} alt="modal-blend-image" />
                  <figcaption>
                    <h2><span>Poly /<br /> Modal blend</span></h2>
                    <p>Bright, Beautiful, and Always Pure</p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                  <img src={linenImage} alt="linen image" />
                  <figcaption>
                    <h2><span>Linen</span></h2>
                    <p>Color with Integrity,<br />Quality without Compromise</p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="homepage-sec-3">
        <div className="container">
          <div className="homepage-sec-3-cont">
            <div class="grid">
              <figure class="effect-sarah" data-aos="fade-right" data-aos-duration="1000">
                <img src={infrastructure} alt="infrastructure-image" />
                <figcaption>
                  <h2> <span>Infrastructure</span></h2>
                  <p className="pb-0">Boiler | Cheese Winding | Cone Winding <br /> Dyeing | ETP | Lab | RF & Hydro | SSF </p>
                  <p className="pt-0"><a href="">View More <span>&#10151;</span></a></p>
                  <a href="#">View more</a>
                </figcaption>
              </figure>
              <div class="effect-sarah green-bg" data-aos="fade-left" data-aos-duration="1000">
                <h2>Recycling 100% waste water</h2>
                <div className="recycle-section">
                  <div className="recycle-content">
                    <span>ZLD</span>
                    <b>ZERO Liquid Discharge</b>
                    <a href="">View More</a>
                  </div>
                  <div className="recycle-image">
                    <img src={recycleImage} alt="recycle-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --------------------------- */}
      <Footer/>
    </div>
  );
};

export default Home;
